module.exports = __webpack_public_path__ + "assets/9a15f040fed096cc9636284a426151d0.mp3";